import PropTypes from 'prop-types';

const propTypes = {
  gridData:PropTypes.shape({
    ID: PropTypes.number,
    NAZOV: PropTypes.string,
    POPIS: PropTypes.string,
    SPOTREBA: PropTypes.shape({
      currYear: PropTypes.shape({
        yearName: PropTypes.number,
        data: PropTypes.array,
      }),
      lastYear: PropTypes.shape({
        yearName: PropTypes.number,
        data: PropTypes.array,
      }),
    }),
  }),
  chartData: PropTypes.shape({
    name: PropTypes.string,
    data: PropTypes.array,
  }),
};

export default propTypes;